import type { RealtimeSubscriptionAdapter } from '../../types/subscription-adapter.types';
import { getAckPayload } from '../../utils/socket-message.util';
import { chunkTopics } from '../../utils/socket-subscription.util';
import {
  COMMUNICATIONS_SOCKET_SUBSCRIBE_ACTION,
  SOCKET_SUBSCRIPTION_MAX_TOPICS,
  communicationsSocketSubscribeAckSchema,
  communicationsSocketSubscribeRequestSchema,
} from '../schemas/subscription.schema';
import { isCommunicationsRealtimeEnabled } from '../utils/release-gate.util';

/** Protected Communications wire policy, including current-generation ACK proof. */
export const communicationsSubscriptionAdapter: RealtimeSubscriptionAdapter = {
  matchesTopic: (topic) => topic.startsWith('communications.'),
  isEnabled: isCommunicationsRealtimeEnabled,
  requiresAuthorization: true,
  serializeRequests: (operation, topics, token) =>
    chunkTopics(topics, SOCKET_SUBSCRIPTION_MAX_TOPICS).map((chunk) => {
      const request = {
        type:
          operation === 'subscribe'
            ? COMMUNICATIONS_SOCKET_SUBSCRIBE_ACTION
            : operation,
        topics: chunk,
        ...(token ? { token } : {}),
      };
      return JSON.stringify(
        operation === 'subscribe'
          ? communicationsSocketSubscribeRequestSchema.parse(request)
          : request
      );
    }),
  getAcknowledgedOperation: (message) => {
    const { action } = getAckPayload(message.payload);
    if (action === 'unsubscribe') return 'unsubscribe';
    if (
      action !== 'subscribe' &&
      action !== COMMUNICATIONS_SOCKET_SUBSCRIBE_ACTION
    ) {
      return undefined;
    }
    return message.type === 'error' ||
      communicationsSocketSubscribeAckSchema.safeParse(message).success
      ? 'subscribe'
      : undefined;
  },
};
